import styled from 'styled-components';

export const EarlyCheckInPopUpwrap = styled.div(
  props => `
    font-size:${props.theme.font.large.font14};
  `,
);

export const EarlyCheckInHeaderWrap = styled.div(
  props => `
    display:flex;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l32};
    justify-content: space-between;
    `,
);

export const EarlyCheckInTitle = styled.div(
  props => `  
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font22};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
  `,
);

export const AddOnOuterWrapper = styled.div(
  props => ` 
    display:flex;
    justify-content: space-between;
    padding ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l32};
    border-top:.1rem solid ${props.theme.colors.blue.bgBlue};
    border-bottom:.1rem solid ${props.theme.colors.blue.bgBlue};
  `,
);

export const AddOnInnerWrapper = styled.div(
  props => `  
    display:flex;
    flex-direction: column;
  `,
);

export const AddOnNameLabel = styled.p(
  props => ` 
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font14};
    font-weight:bold;
    margin: 0 0 ${props.theme.spacing.large.l20} 0;
  `,
);

export const PayAtHotelBtn = styled.button(
  props => ` 
    color:${props.theme.colors.white.base};
    font-size:${props.theme.font.large.font14};
    font-weight:bold;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    border:none;
    background-image: linear-gradient(275deg, #ff6d38, #ff3a5c);
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l15};
    text-transform:uppercase;
    position:relative;
    top:-.8rem;
  
  `,
);

export const AddOnNameData = styled.p(
  props => ` 
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font16};
  `,
);

export const QuantityData = styled.p(
  props => ` 
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font16};
    text-align:center;

  `,
);

export const AddOnAmountData = styled.p(
  props => ` 
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font16};
    text-align:center;
  `,
);

export const EarlyCheckInBtn = styled.button(
  props => `  
    color:${props.theme.colors.white.base};
    font-size:${props.theme.font.large.font14};
    font-weight:bold;
    border-radius: ${props.theme.misc.borderRadius.base};
    border:none;
    background: ${props.theme.colors.goBrand.blue};
    padding: ${props.theme.spacing.base};
    float:right;
    margin: ${props.theme.spacing.base} ${props.theme.spacing.large.l32};
  
  `,
);
